import styles from "./navigation.module.css";
import Button from "./../../components/button/button";
import Icon from "./../../icons/icon";

const Navigation = ({ scrollToAbout, instantScroll, data }) => {
  return (
    <nav className={`${styles.navigation} container`}>
      <div className={styles.left}>
        <p onClick={scrollToAbout}>{data[0]?.navigation[0]}</p>
        <p onClick={instantScroll}>{data[0]?.navigation[1]}</p>
      </div>
      <div className={styles.logo}>
        <Icon type={"Logo"} />
      </div>
      <div className={styles.right}>
        <p>{data[0]?.buttons[0]}</p>
        <Button>{data[0]?.buttons[1]}</Button>
      </div>
    </nav>
  );
};

export default Navigation;
